<template>
    <v-card>
        <v-card-title>
            <v-flex xs12 sm6>
                <div class="headline">Consulta de bancas</div>
            </v-flex>
            <v-flex xs12 sm5>
                <v-text-field
                        append-icon="search"
                        label="Pesquisar"
                        single-line
                        hide-details
                        v-model="search"></v-text-field>
            </v-flex>
        </v-card-title>
        <v-card-title>
            <exam-filters v-model="filters" :semester-required="true"></exam-filters>
        </v-card-title>
        <v-card-title v-if="activeMessages.length > 0">
            <v-flex xs12>
                <v-alert :color="message.type" value="true" v-for="(message, idx) in activeMessages" :key="'message_'+idx" dismissible v-model="message.show">
                    {{ message.text }}
                </v-alert>
            </v-flex>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="filteredItems"
            :search="search"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :no-data-text="noData"
            :no-results-text="noResult"
            :rows-per-page-text="rowsPerPageT"
            class="elevation-1">
            <template slot="items" slot-scope="props">
                <tr v-if="props.item">
                    <td>{{ props.item.id }}</td>
                    <td class="no-padding">
                        <ul class="no-padding">
                            <ol class="no-padding studentName" v-for="(studentName, id) in props.item.studentName" :key="id">
                                {{ studentName }}
                            </ol>
                        </ul>
                    </td>
                    <td>{{ props.item.date | moment('DD/MM/YYYY') }}</td>
                    <td>{{ props.item.hour }}</td>
                    <td>{{ props.item.place }}</td>
                    <td>
                        <v-chip small :class="[getExamStatusClass(props.item), 'white--text']">
                            {{ getExamStatus(props.item) }}
                        </v-chip>
                    </td>
                    <td>{{ formataNota(props.item.finalScore) }}</td>
                    <td>
                        <router-link :to="{ name: 'examPlan', params: { id: props.item.id } }" v-if="props.item.situation != 'Finalizada'"> <!-- v-if="!props.item.finalScore || props.item.finalScore == 0"> -->
                            <v-btn color="info" floating small dark fab title="Modificar planejamento da banca">
                                <v-icon dark>schedule</v-icon>
                            </v-btn>
                        </router-link>
                        <v-btn color="deep-orange lighten-2" floating small dark fab title="Notificar participantes" @click.stop="notifyAttendees(props.item)"
                            v-if="!props.item.notificationDate">
                            <v-icon dark>mail_outline</v-icon>
                        </v-btn>
                        <v-btn color="success" floating small dark fab :title="'Os participantes foram notificados em ' + formatDate(props.item.notificationDate)" @click.stop="notifyAttendees(props.item)"
                            v-else>
                            <v-icon dark>email</v-icon>
                        </v-btn>
                        <v-btn color="cyan darken-1" floating small dark fab title="Ver fichas de avaliação" @click.stop="showExamEvaluation(props.item)">
                            <v-icon dark>gavel</v-icon>
                        </v-btn>
                        <router-link :to="{ name: 'examDetail', params: { id: props.item.id } }" v-if="props.item.situation != 'Finalizada'"> <!-- v-if="!props.item.finalScore || props.item.finalScore == 0"> -->
                            <v-btn color="success" floating small dark fab title="Encerrar banca">
                                <v-icon dark>school</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'examDetail', params: { id: props.item.id } }" v-if="props.item.situation != 'Finalizada'"> <!-- v-if="props.item.finalScore > 0"> -->
                            <v-btn color="info" floating small dark fab title="Ver banca">
                                <v-icon dark>description</v-icon>
                            </v-btn>
                        </router-link>
                        <v-btn color="orange" floating small dark fab title="Ver lista de presença e certificações" @click.stop="showExamAttendance(props.item)">
                            <v-icon dark>playlist_add_check</v-icon>
                        </v-btn>
                        <v-btn color="grey darken-2" floating small dark fab title="Emitir documentos" @click.stop="showExamDocuments(props.item)">
                            <v-icon dark>folder</v-icon>
                        </v-btn>
                        <v-btn color="error" floating small dark fab title="Cancelar banca" @click.stop="dialogCancelBanca(props.item)" v-if="props.item.situation != 'Finalizada'">
                            <v-icon>clear</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-card-text>
            <p>Acima estão listadas as bancas que você participa ou coordena.</p>
        </v-card-text>
        <fullscreen-spinner></fullscreen-spinner>
        <v-dialog v-model="evaluationDialog" fullscreen lazy>
            <exam-evaluations :exam-id="selectedExam">
                <template slot="actions">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="evaluationDialog = false">Fechar</v-btn>
                </template>
            </exam-evaluations>
        </v-dialog>
        <v-dialog v-model="attendanceDialog" fullscreen lazy>
            <exam-attendance :exam-id="selectedExam">
                <template slot="actions">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="attendanceDialog = false">Fechar</v-btn>
                </template>
            </exam-attendance>
        </v-dialog>
        <v-dialog v-model="documentsDialog" fullscreen lazy>
            <exam-documents :exam-id="selectedExam">
                <template slot="actions">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="documentsDialog = false">Fechar</v-btn>
                </template>
            </exam-documents>
        </v-dialog>

        <v-dialog v-model="showDialogBanca" fullscreen lazy>
            <exam-documents>
                <template slot="actions">
                    <v-content>
                        <v-container fluid fill-height>
                        <v-layout>
                            <v-flex offset-xs2 offset-sm2 offset-md2 xs10 sm10 md10>
                                <v-card class="elevation-12">
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title>Cancelar Banca</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-tooltip right>
                                    <v-btn slot="activator" icon large href="https://codepen.io/johnjleider/pen/wyYVVj" target="_blank">
                                        <v-icon large>mdi-codepen</v-icon>
                                    </v-btn>
                                    <span>Codepen</span>
                                    </v-tooltip>
                                </v-toolbar>
                                <v-card-text>
                                    <v-form>
                                    <v-text-field prepend-icon="record_voice_over" v-model="obs_of_situation" label="Motivo do cancelamento" type="text"></v-text-field>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="error" @click.stop="cancelarBanca(dialogItem)">Confirmar Cancelamento</v-btn>
                                </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-content>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="info"
                        @click="showDialogBanca = false"
                        :style="styleButtonDialog"
                    >Fechar</v-btn>
                </template>
            </exam-documents>
        </v-dialog>
    </v-card>
</template>

<script>
    import auth from '../auth'
    import { noData, noResult, rowsPerPageT } from './../locale/vuetify'
    import ExamFilters from './ExamFilters.vue'
    import ExamEvaluations from './ExamEvaluations.vue'
    import ExamAttendance from './ExamAttendance.vue'
    import ExamDocuments from './ExamDocuments.vue'
    import moment from 'moment'

    export default {
        name: 'ExamList',
        components: {
            ExamFilters,
            ExamEvaluations,
            ExamAttendance,
            ExamDocuments
        },
        data() {
            return {
                headers: [
                    { text: 'Id', align: 'left', value: 'id' },
                    { text: 'Aluno', align: 'left', value: 'studentName' },
                    /*{ text: 'Tema', align: 'left', value: 'topic' },
                    { text: 'Título', align: 'left', value: 'title' },*/
                    { text: 'Data', align: 'left', value: 'date' },
                    { text: 'Hora', align: 'left', value: 'hour' },
                    { text: 'Local', align: 'left', value: 'place' },
                    { text: 'Situação', align: 'left', value: 'status'},
                    //{ text: 'Examinadores', align: 'left', value: 'examinersName' },
                    { text: 'Nota final', align: 'left', value: 'finalScore' },
                    { text: 'Ações', align: 'center', value: 'actions' }
                ],
                user: auth.user,
                attendanceList: [],
                pendenciaDoPresidente: [],
                canCertify: false,
                hasPendingCertification: false,
                items: [],
                totalItems: -1,
                search: '',
                pagination: {
                    rowsPerPage: 25,
                    sortBy: 'date',
                    descending: true
                },
                loading: false,
                noData: noData,
                noResult: noResult,
                rowsPerPageT: rowsPerPageT,
                selectedExam: null,
                evaluationDialog: false,
                attendanceDialog: false,
                documentsDialog: false,
                messages: [],
                filters: {},
                showDialogBanca: false,
                dialogItem: null,
                obs_of_situation: null,
                styleButtonDialog: {
                    position: 'absolute !important',
                    bottom: '15px',
                    right: '15px'
                }
            }
        },
        computed: {
            activeMessages: function() {
                return this.messages.filter(function (message) {
                    return message['date'] >= (Date.now() - (5 * 1000))
                })
            },
            filteredItems() {
                return this.items.filter(item => item.situation !== 'Cancelada');
            }
        },
        watch: {
            pagination: {
                handler() { this.refresh() },
                deep: true
            },
            filters: {
                handler() { this.refresh() },
                deep: true
            }
        },
        methods: {
            loadAttendance: function (exam) {
            this.$http.post("attendanceList", { exam: exam }).then((response) => {        
                const attendanceList = response.body.attendanceList;
                // console.log(response)
                // var present = 0;
                // const returno =  Object.values(attendanceList).map((presencas) => {
                //     // se present tiver 0, significa que ele não estava presente, mas foi feita a chamada
                //     if (presencas.present == "") {
                //         present++;
                //     }
                //     if (present > 0) {
                //         return  true;
                //     }

                //     return false;
                // });
                //         // console.log(returno)
                //         return returno;
            });
            },
            bancasQuePreside(bancas) {
            const bancasQueEhPresidente = bancas.filter((valores) => {
                // return valores.chair == "61319404014" && valores.situation != 'Cancelada';
                return valores.chair == this.user.id && valores.situation != 'Cancelada';
            });
            this.pendencias(bancasQueEhPresidente);
            },
            pendencias(bancas) {
                var pendencias = [];
            bancas.map((b) => {
                var certificacaoPendente = b.certification == null || b.certification == "" ? true : false;
                var ataPendente = b.ata == null || b.ata =="" ? true : false;
                var finalizada = b.situation == "Finalizada" ? true : false;
                var present = 0;

                pendencias.push({'banca': b.id, 'titulo':b.title, certificacaoPendente, ataPendente, finalizada})
                this.pendenciaDoPresidente = pendencias;
            });
            },
            formatDate: function (date) {
                return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            },
            mountSearchString() {
                let searchString = [];

                for (let key in this.filters) {
                    let value = this.filters[key]
                    if (!!value && key != 'view') {
                        searchString[key] = value
                    }
                }
                searchString['search'] = this.search;

                let str = "";
                for (let key in searchString) {
                    if (str != "") {
                        str += "&";
                    }
                    str += key + "=" + encodeURIComponent(searchString[key]);
                }

                return str

            },
            formataNota(finalScore) {
                return finalScore.slice(0, -1);               
            },
            getDataFromApi() {
                this.loading = true
                return new Promise((resolve, reject) => {
                    const { sortBy, descending, page, rowsPerPage } = this.pagination
                    let offset = 0;
                    if (rowsPerPage > 0) offset = (page - 1) * rowsPerPage
                    const params = {
                        search: this.mountSearchString(),
                        sortBy: this.pagination.sortBy,
                        descending: this.pagination.descending,
                        limit: rowsPerPage,
                        offset: offset
                    }

                    // exams | searchExamSchedule
                    this.$http.post('searchExamSchedule', params).then(response => {
                        this.loading = false
                        const items = response.body
                        const total = parseInt(response.headers.get('X-Pagination-Total-Count'))
                        resolve( { items, total })
                    }, response => {
                        console.error('Erro ao carregar as bancas do servidor.')
                        console.log(response)
                    })
                })
            },
            showExamEvaluation(exam) {
                this.selectedExam = exam.id
                this.evaluationDialog = true
            },
            showExamAttendance(exam) {
                this.selectedExam = exam.id
                this.attendanceDialog = true
            },
            showExamDocuments(exam) {
                this.selectedExam = exam.id
                this.documentsDialog = true
            },
            getExamStatus(exam) {
                /* Segue tipos de status
                'Atrasada'
                'Em andamento'
                'Finalizada'
                'Pendente'
                'Exluida'
                */

                let status = 'Pendente'

                // TODO verificar outras situações da banca
                /*
                if (exam.finalScore > 0)        status = 'Finalizada'
                return status
                */

                return exam.situation
            },
            getExamStatusClass(exam) {
                let status = this.getExamStatus(exam),
                    classes = []
                if (status == 'Atrasada')       classes.push('warning')
                if (status == 'Em andamento')   classes.push('info')
                if (status == 'Finalizada')     classes.push('success')
                if (status == 'Pendente')       classes.push('grey darken-2')
                return classes
            },
            notifyAttendees(exam) {
                if (exam.notificationDate) {
                    this.addMessage('warning', 'Os participantes da banca ' + exam.id + ' já foram notificados em ' + this.formatDate(exam.notificationDate))
                    return false
                }
                let status = this.getExamStatus(exam)
                if (status == 'Finalizada') {
                    this.addMessage('error', 'Os participantes da banca ' + exam.id + ' não serão notificados porque a banca já foi finalizada.')
                    return false
                }
                this.$http.post('notifyAttendees', { 'exam': exam.id }).then(response => {
                    if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                        this.addMessage('success', 'Os participantes da banca ' + exam.id + ' foram notificados.')
                        exam.notificationDate = moment().format('YYYY-MM-DD')
                    } else {
                        this.addMessage('error', 'Não foi possível notificar os participantes da banca ' + exam.id + '.')
                    }
                }, response => {
                    this.addMessage('error', 'Não foi possível notificar os participantes da banca ' + exam.id + '.')
                    console.error('Erro ao solicitar a notificação dos participantes ao servidor.')
                    console.log(response)
                })
            },
            addMessage(type, text) {
                this.messages.push({
                    'type': type,
                    'text': text,
                    'date': Date.now(),
                    'show': true
                })
            },
            refresh() {
                this.getDataFromApi().then(data => {
                    this.items = data.items;
                    this.totalItems = data.total;

                    this.bancasQuePreside(data.items);
                })
            },
            cancelarBanca: function () {
                /* Segue tipos de status
                'Atrasada'
                'Em andamento'
                'Finalizada'
                'Pendente'
                'Cancelada'
                */

                let item = this.dialogItem;
                item.obs_of_situation = this.obs_of_situation;

                if(item.obs_of_situation == null) {
                    this.$swal({
                        type: 'warning',
                        text: 'Por favor preencha o motivo do cancelamento.',
                        showConfirmButton: false,
                        timer: 2500
                    })
                    return false;
                }

                if(item.obs_of_situation.length < 10) {
                    this.$swal({
                        type: 'info',
                        text: 'Por favor, informe um motivo melhor definido!',
                        showConfirmButton: false,
                        timer: 2500
                    })
                    return false;
                }

                let _this = this;

                this.$http.put('cancelarBanca', {
                    id: item.id,
                    obs_of_situation: item.obs_of_situation,
                    situation: 'Cancelada'
                }).then(response => {
                    console.log(response.body);

                    if(response.body.success) {
                        _this.$set(item, 'situation', 'Cancelada')
                        _this.$store.commit('setLastModifiedExam', item)

                        _this.$swal({
                            type: 'success',
                            showConfirmButton: false,
                            timer: 2500
                        }).then((res) => {
                            window.location.reload();
                        })
                    }else {
                        _this.$swal({
                            type: 'error',
                            text: response.body.result,
                            showConfirmButton: false,
                            timer: 3000
                        })
                    }
                }, response => {
                    console.log(response);
                    console.log(response.body);

                    console.error('Erro ao submeter os dados para o servidor.')
                    _this.handleBadResponse(response)
                });

                /*
                this.$swal({
                    type: 'warning',
                    title: 'Atenção',
                    text: "Deseja realmente excluir esta banca?",
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Sim',
                    showCancelButton: true,
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    _this.$http.put('cancelarBanca', {
                        id: item.id,
                        situation: 'Cancelada'
                    }).then(response => {
                        console.log(response.body);

                        if(response.body.success) {
                            _this.$set(item, 'situation', 'Cancelada')
                            _this.$store.commit('setLastModifiedExam', item)

                            _this.$swal({
                                type: 'success',
                                showConfirmButton: false,
                                timer: 2500
                            })
                        }else {
                            _this.$swal({
                                type: 'error',
                                text: response.body.result,
                                showConfirmButton: false,
                                timer: 3000
                            })
                        }
                    }, response => {
                        console.log(response);
                        console.log(response.body);

                        console.error('Erro ao submeter os dados para o servidor.')
                        _this.handleBadResponse(response)
                    });
                }).catch((result) => {
                    return false;
                })
                */
            },
            dialogCancelBanca (item) {
                this.showDialogBanca = true;
                this.dialogItem = item
            }
        },
        mounted() {
            this.refresh();
        }
    }
</script>

<style>
.no-padding {
    padding: 0 !important;
    margin: 0 !important;
}
.studentName {
    font-size: 10px;
    margin-top: 5px !important;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ExamList.vue?4a082050